import type { FaireProductEntity } from "../../entity_types/product";

export const p_fr93cef8pc: FaireProductEntity = {
  token: "p_fr93cef8pc",
  type: "product",
  name: "Doggy Thank You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/88c11bf103d917b790f4e94c96ff2e8032340d71183959f31b9354c06b9fa7e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/334d681731a3dfd027f53b1e9a1d82d91c5413d5419eaf0ca1571e4513faf749.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description:
    "A thank you so sincere, even these dogs feel it. Why else would they sit still long enough for their paintings to be done?! Well done, fellas.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:43.391Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
